import { config } from './config';
import EventTracker from './EventTracker';
import getCookie from '../functions/getCookie';

// TODO: Clarify tracking/analytics/marketing script usages

/**
 * Statistic script GTM
 */
const appendNecessaryScript = () => {
    const head = document.getElementsByTagName('head')[0];

    // Get current consent from cookies
    const consent = {
        statistics: getCookie('consent-type-statistics'),
        marketing: getCookie('consent-type-marketing'),
    };

    // Set consents to 'denied' if no cookie is set
    if (!consent.statistics) {
        consent.statistics = 'denied';
    } else {
        consent.statistics = 'granted';
    }

    // Do the same for marketing
    if (!consent.marketing) {
        consent.marketing = 'denied';
    } else {
        consent.marketing = 'granted';
    }

    // Google Consent Mode initialisation
    const gcmInitScript = document.createElement('script');
    const gcmScriptContent = `// Define dataLayer and the gtag function.
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}

        // Set default consents
        gtag('consent', 'default', {
            'ad_storage': '${consent.marketing}',
            'ad_user_data': '${consent.marketing}',
            'ad_personalization': '${consent.marketing}',
            'analytics_storage': '${consent.statistics}'
        });
    `;
    const gcmInlineScript = document.createTextNode(gcmScriptContent);
    gcmInitScript.appendChild(gcmInlineScript);
    head.appendChild(gcmInitScript);

    // Google Tag Manager initialisation
    const gtmSettings = config.scriptSettings.statistics.tracking.gtm;
    const gtmScript = document.createElement('script');

    const scriptContent = `/* Start Init GTM Script from SFCookieConsent */ 
        var dataLayer = dataLayer || [];
        var sdl = {};
        sdl['gtm.start'] = new Date().getTime();
        sdl['pageUid'] = window.pageUid;
        sdl.event = 'gtm.js';

        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(sdl);
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${gtmSettings.stageKey}';
            f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${gtmSettings.key}');
        /* End Init GTM Script from SFCookieConsent */ 
        `;

    if(gtmSettings.key !== 'disabled') {
        const inlineScript = document.createTextNode(scriptContent);
        gtmScript.appendChild(inlineScript);
        head.appendChild(gtmScript);
    }
};

const appendGoogleTracking = () => {
    EventTracker.initTracking();
};

/**
 * Statistic script Hotjar
 */

const appendHotjarTracking = () => {
    // const hotjarSettings = config.scriptSettings.statistics.tracking.hotjar;
    const hotjarScript = document.createElement('script');

    const scriptContent = `/* Start Init Hotjar Script from SFCookieConsent */ 
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:3768072,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        /* End Init Hotjar Script from SFCookieConsent */ 
        `;

    const inlineScript = document.createTextNode(scriptContent);
    hotjarScript.appendChild(inlineScript);

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(hotjarScript);
};

/**
 * Statistic script Xing
 */

const appendXingTracking = () => {
    // const xingSettings = config.scriptSettings.statistics.tracking.xing;
    const xingScript = document.createElement('script');

    const scriptContent = `/* Start Init Xing Script from SFCookieConsent */ 
    !function(n,t,i,e,c,d){n.xtp||(c=n.xtp={xingTrk:function(){c.queue.push(arguments)}},c.queue=[],d=t.createElement("script"),d.src=i,d.onload=e,d.async=!0,t.head.appendChild(d))}(window,document,"https://static.xingcdn.com/xingtrk/index.js",function(){xtp.init("fa266a3e-a13a-435c-ac46-2f883b880619")});
    /* Xing Init Hotjar Script from SFCookieConsent */ `;

    const inlineScript = document.createTextNode(scriptContent);
    xingScript.appendChild(inlineScript);

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(xingScript);
};

/**
 * Statistic script Piwik
 */

// const appendPiwikTracking = () => {
//     const piwikSettings = config.scriptSettings.statistics.tracking.piwik;
//
//     /* eslint-disable no-underscore-dangle */
//     const _paq = window._paq || [];
//     window._paq.push(['trackPageView']);
//     window._paq.push(['enableLinkTracking']);
//
//     const hostnameArray = window.location.hostname.split('.');
//     let siteID = 1;
//
//     if (hostnameArray.includes('innenstadt-freising') || hostnameArray.includes('freising-innenstadt')
//         || hostnameArray.includes('innenstadt')) {
//         siteID = 2;
//     }
//
//     const u = 'https://statistik.freising.de/';
//     _paq.push(['setTrackerUrl', `${u}piwik.php`]);
//     _paq.push(['setSiteId', siteID]);
//     const d = document;
//     const g = d.createElement('script');
//     const s = d.getElementsByTagName('script')[0];
//     g.type = 'text/javascript';
//     g.defer = true;
//     g.async = true;
//     g.src = `${u}piwik.js`;
//     s.parentNode.insertBefore(g, s);
// };

/**
 * Marketing scripts
 */
// const appendFacebookStuff = () => {
//     return false;
// };

export const appendNecessaryScripts = () => {
    appendNecessaryScript();
};

export const appendStatisticScripts = () => {
    appendGoogleTracking();
    appendHotjarTracking();
    // appendPiwikTracking();

    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
            analytics_storage: 'granted',
        });
    }
};

export const appendMarketingScripts = () => {
    // Add marketing scripts here
    appendXingTracking();
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
            ad_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
        });
    }
};
